import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addAllProducts,
  addProduct,
  updateProduct,
} from "Redux/Reducer/ProductReducer";
import AxiosService from "utils/AxiosService";

function UseProductHook() {
  const dispatch = useDispatch();

  // ✅ Create Product
  const createProduct = async (data) => {
    try {
      let res = await AxiosService.post("/vendor/createProduct", data);
      if (res.status === 201) {
        toast.success(res.data.message);
        dispatch(addProduct(res?.data?.product));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message||"Failed to create product");
      console.log(error?.response?.data?.message || error.message);
    }
  };

  // ✅ Get All Products
  const getAllProduct = async () => {
    try {
      let res = await AxiosService.get("/vendor/getProductByVendor");
      if (res.status === 200) {
        dispatch(addAllProducts(res?.data?.products));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Update Product
  const updateProducts = async (data) => {
    try {
      let res = await AxiosService.put(
        `/vendor/updateProduct/${data?._id}`,
        data
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        dispatch(updateProduct(res?.data?.product));
      }
    } catch (error) {
     toast.error(error?.response?.data?.message||"Failed to update product");
      console.log(error);
    }
  };

  // ✅ Create Visit Entry (by Vendor)
  const createVisitEntry = async (data) => {
    try {
      let res = await AxiosService.post("/vendor/createVisitEntry", data);
      if (res.status === 201) {
        toast.success(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to create visit entry");
    }
  };

  // ✅ Get Visit Entries (by Vendor)
  const getVisitEntries = async () => {
    try {
      let res = await AxiosService.get("/vendor/getVisitEntries");
      if (res.status === 200) {
        return res.data.visits; // optionally dispatch if you want to store in Redux
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Update Visit Entry
  const updateVisitEntry = async (id, data) => {
    try {
      let res = await AxiosService.put(`/vendor/updateVisitEntry/${id}`, data);
      if (res.status === 200) {
        toast.success(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update visit entry");
    }
  };

  return {
    getAllProduct,
    createProduct,
    updateProducts,
    createVisitEntry,
    getVisitEntries,
    updateVisitEntry,
  };
}

export default UseProductHook;
